import { render, staticRenderFns } from "./Ispezione.vue?vue&type=template&id=53abf1d0&"
import script from "./Ispezione.vue?vue&type=script&lang=ts&"
export * from "./Ispezione.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports